module.exports = __webpack_public_path__ + "static/1touch.io-7b56bb628e2983c4b239f4334150281f.jpg";